<template>
    <header id="header">
        <Menu v-if="isVisible"/>
    </header>
</template>

<script>
import Menu from "@/components/menu/menu"
import { mapState } from 'vuex'

export default {
    name: 'Header',
    components: { Menu },
    computed: mapState(['isVisible'])
}
</script>

<style>
</style>